import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { monthLabel, shiftMonth } from "@/lib/format";
import { cn } from "@/lib/utils";

/** ‹ Monat › plus an "Alle Monate" toggle; value null = all months. */
export function MonthPicker({ value, onChange, fallback }: { value: string | null; onChange: (m: string | null) => void; fallback: string }) {
  const month = value ?? fallback;
  const all = value === null;
  return (
    <div className="flex items-center gap-1">
      <div className={cn("flex items-center rounded-md border", all && "opacity-50")}>
        <Button variant="ghost" size="icon-sm" aria-label="Vorheriger Monat" disabled={all} onClick={() => onChange(shiftMonth(month, -1))}>
          <ChevronLeft />
        </Button>
        {/* Fixed width: switching months must not shift the controls next to it. */}
        <span className="w-32 text-center text-sm tabular-nums" aria-live="polite">{monthLabel(month)}</span>
        <Button variant="ghost" size="icon-sm" aria-label="Nächster Monat" disabled={all} onClick={() => onChange(shiftMonth(month, 1))}>
          <ChevronRight />
        </Button>
      </div>
      <Button variant={all ? "secondary" : "ghost"} size="sm" aria-pressed={all} onClick={() => onChange(all ? fallback : null)}>
        Alle Monate
      </Button>
    </div>
  );
}
